import { Box, Button, Divider, Typography, useTheme } from '@mui/material';

import { ClaimedListType } from '@/types/staking/read';

export default function PortfolioClaimedCard({ item }: { item: ClaimedListType }) {
  // theme
  const theme = useTheme();

  if (!item) {
    return;
  }
  // useEffect(() => {
  //   function isResGetStakeCall(item: ResRewardSchedules | ResGetStakeCall): item is ResGetStakeCall {
  //     const re = (item as ResGetStakeCall).amountStaked !== undefined;
  //     setTemp(item);
  //     return (item as ResGetStakeCall).amountStaked !== undefined;
  //   }

  //   if (!item) {
  //     return;
  //   }
  //   isResGetStakeCall(item);
  //   return () => {};
  // }, [item]);
  const handleButtonClick = (aData: string) => {
    const src =
      process.env.NODE_ENV === 'development'
        ? `https://amoy.polygonscan.com/tx/${aData}`
        : `https://polygonscan.com/tx/${aData}`;
    window.open(src);
  };
  return (
    <Box
      sx={{
        borderRadius: '20px',
        border: `0.5px solid ${theme.greyscale.lightgrey1}`,
        boxShadow: '0px 0px 4px 0px #00000026',
      }}
    >
      <Box
        sx={{
          margin: '24px 24px',
          background: theme.background.default,
          borderRadius: '10px',
          border: `0.5px solid ${theme.greyscale.grey1}`,
        }}
      >
        {/* <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '8px',
            borderBottom: `0.5px solid ${theme.greyscale.lightgrey2}`,
          }}
        >
          <Typography variant="body2" color={theme.greyscale.grey1}>
            No.
          </Typography>

          <Box sx={{ textAlign: 'right' }}>
            <Typography variant="subtitle2" color={theme.greyscale.darkgrey2}>
              {item.no}
            </Typography>
          </Box>
        </Box> */}

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '8px',
            borderBottom: `0.5px solid ${theme.greyscale.lightgrey2}`,
          }}
        >
          <Typography variant="body2" color={theme.greyscale.grey1}>
            Stake Amount
          </Typography>

          <Box sx={{ textAlign: 'right' }}>
            <Typography variant="subtitle2" color={theme.greyscale.darkgrey2}>
              {item.totStakeAmt}{' '}
              <Typography display={'inline'} variant="body4" color={theme.greyscale.darkgrey2}>
                SFL
              </Typography>
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '8px',
            borderBottom: `0.5px solid ${theme.greyscale.lightgrey2}`,
          }}
        >
          <Typography variant="body2" color={theme.greyscale.grey1}>
            Reward
          </Typography>

          <Box sx={{ textAlign: 'right' }}>
            <Typography variant="subtitle2" color={theme.greyscale.darkgrey2}>
              {item?.rewardAmt}
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '8px',
            borderBottom: `0.5px solid ${theme.greyscale.lightgrey2}`,
          }}
        >
          <Typography variant="body2" color={theme.greyscale.grey1}>
            Cumulative Number of Rewards
          </Typography>

          <Box sx={{ textAlign: 'right' }}>
            <Typography variant="subtitle2" color={theme.greyscale.darkgrey2}>
              {item.rewardCnt}
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '8px',
          }}
        >
          <Typography variant="body2" color={theme.greyscale.grey1}>
            Tx
          </Typography>

          <Box sx={{ textAlign: 'right' }}>
            <Typography variant="subtitle2" color={theme.greyscale.darkgrey2}>
              <Button color="primary" onClick={() => handleButtonClick(item.rewardHash)}>
                ↗
              </Button>
            </Typography>
          </Box>
        </Box>

        {/* <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '8px',
          }}
        >
          <Typography variant="body2" color={theme.greyscale.grey1}>
            Rewards
          </Typography>

          <Box sx={{ textAlign: 'right' }}>
            <Typography variant="subtitle2" color={theme.greyscale.darkgrey2}>
              {item.rewards.toLocaleString()}{' '}
              <Typography display={'inline'} variant="body4" color={theme.greyscale.darkgrey2}>
                USD
              </Typography>
            </Typography>
          </Box>
        </Box> */}
      </Box>

      {/* <Box
        sx={{
          width: '100%',
          height: '0.5px',
          margin: '24px 0px',
          borderBottom: `0.5px solid ${theme.greyscale.lightgrey2}`,
        }}
      /> */}

      {/* <Box
        sx={{
          margin: '24px 16px',
        }}
      >
        <CommonButton
          sx={{
            borderRadius: '10px',
            padding: '12px 20px',
            width: '100%',
          }}
          handleClick={() => handleOpenModal(item.status)}
          text={item.status === 'claim' ? 'Claim' : 'Unstake'}
          color={theme.background.blue}
          bgColor={'#ffffff'}
          border={theme.background.blue}
          variant="body2"
        />
      </Box> */}
    </Box>
  );
}
